module.exports = __webpack_public_path__ + "static/lb-bc789b21fd21dd46a518649b0f8f9712.svg";